import { Typography } from '@sanlam-glacier/app-common/components';
import { ClientTable } from '../components/molecules/widgets/content/client-table/ClientTable';
import { TransactionsTable } from '../components/molecules/widgets/content/transactions-table/TransactionsTable';
import { ToDoList } from '../components/molecules/widgets/content/to-do-list/ToDoList';

export enum TableType {
  clientTable = 'clientTable',
  latestTransactions = 'latestTransactions',
  ToDoList = 'toDoList'
}

export interface TableProps<T = unknown> {
  tableType: TableType | undefined;
  data: T[] | undefined;
}

const TableRenderer = (tableProps: TableProps) => {
  const table = (type: TableType | undefined) => {
    switch (type) {
      case TableType.clientTable:
        return <ClientTable {...tableProps} />;
      case TableType.latestTransactions:
        return <TransactionsTable {...tableProps} />;
      case TableType.ToDoList:
        return <ToDoList />;
      default:
        return (
          <Typography
            variant={Typography.VARIANT.B3}
            weight={Typography.WEIGHT.LIGHT}
            color={Typography.COLOR.SECONDARY}
          >
            Invalid Chart
          </Typography>
        );
    }
  };

  return <div>{table(tableProps.tableType)}</div>;
};

export default TableRenderer;
